import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { httpInterceptorProviders } from './http-interceptors/index';

import { ActionComponent } from './action/action.component';
import { ActionsComponent } from './actions/actions.component';
import { AssessmentComponent } from './assessment/assessment.component';
import { FooterComponent } from './footer/footer.component';
import { HelpComponent } from './help/help.component';
import { HomeComponent } from './home/home.component';
import { LoggerService } from './logger.service';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { MessageComponent } from './message/message.component';
import { MessageService } from './message.service';
import { PageComponent } from './page/page.component';
import { QuestionComponent } from './question/question.component';
import { QuestionHelpComponent } from './question-help/question-help.component';
import { QuestionNotesComponent } from './question-notes/question-notes.component';
import { QuestionsComponent } from './questions/questions.component';
import { QuestionService } from './question.service';
import { ReportComponent } from './report/report.component';
import { RewardComponent } from './reward/reward.component';
import { RewardsComponent } from './rewards/rewards.component';
import { RisksComponent } from './risks/risks.component';
import { RoughcheckComponent } from './roughcheck/roughcheck.component';
import { RoughcheckService } from './roughcheck.service';
import { RoughcheckFormComponent } from './roughcheck-form/roughcheck-form.component';
import { SectionComponent } from './section/section.component';
import { SectionsComponent } from './sections/sections.component';
import { SessionSetService } from './session-set.service';
import { ReportsComponent } from './reports/reports.component';
import { QuestionFeedbackComponent } from './question-feedback/question-feedback.component';

@NgModule({
  declarations: [
    ActionComponent,
    ActionsComponent,
    AppComponent,
    AssessmentComponent,
    FooterComponent,
    HelpComponent,
    HomeComponent,
    MainMenuComponent,
    MessageComponent,
    PageComponent,
    QuestionComponent,
    QuestionHelpComponent,
    QuestionNotesComponent,
    QuestionsComponent,
    RewardComponent,
    RewardsComponent,
    RisksComponent,
    ReportComponent,
    RoughcheckFormComponent,
    RoughcheckComponent,
    SectionComponent,
    SectionsComponent,
    ReportsComponent,
    QuestionFeedbackComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
  ],
  providers: [
    httpInterceptorProviders,
    MessageService,
    RoughcheckService,
    QuestionService,
    SessionSetService,
    Title,
    LoggerService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

